import { useViewport } from '@sbt-web/hooks';
import { wholeNumberDigit } from '@sbt-web/utils';
import classNames from 'classnames';
import React from 'react';
import ownClasses from './AdsCount.module.scss';

const AdsCount = ({ children: total }: { children: number }) => {
  const { isMobile } = useViewport();

  return (
    <p
      className={classNames('caption', 'total-ads', ownClasses['total-ads'], {
        book: isMobile,
        small: isMobile,

        semibold: !isMobile,
        normal: !isMobile,
      })}
    >
      {`${wholeNumberDigit.format(total)} risultat${total === 1 ? 'o' : 'i'}`}
    </p>
  );
};

export default AdsCount;
